<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('appealoppsition.appeal.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('appealoppsition.title') }} > </span>
            <span class="middle_loc">{{ $t('appealoppsition.appeal.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">

          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('appealoppsition.appeal.fields.step_01') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('appealoppsition.appeal.fields.step_02') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03 active">
              <h2>{{ $t('appealoppsition.appeal.fields.step_03') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step04" v-if="paymentYn">
              <h2>{{ $t('appealoppsition.appeal.fields.step_04') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.payment') }}</p>
            </v-flex>
          </v-layout>

          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2">
              <v-tabs
                class="my_app_tabs_data type2"
                hide-slider
                grow
                v-model="activeTab"
              >
                <v-tab href="#tab-1" class="mw-200">{{ $t('appealoppsition.appeal.fields.request_data')  }}</v-tab>
                <v-tab href="#tab-2" class="mw-200">{{ $t('appealoppsition.appeal.fields.attached_documents')  }}</v-tab>

                <v-tab-item value="tab-1">
                  <ApplicationInformation2 :receipt_no="receipt_no" />

                  <v-layout class="inner_contents mt-30" column>
                    <v-flex class="item_box pa-0" style="border-bottom: none">
                      <h2 class="m_title solo mt-35">{{ $t('appealoppsition.appeal.fields.type_of_appeal') }}</h2>
                      <v-col cols="12" class="pa-0 mt-20">
                        <div class="input_checkbox_type_basic radio_dailog_type row ma-0 pl-15 pr-15">
                          <v-radio-group
                            row
                            v-model="appeal.appeal_type_code"
                            class="view__radio"
                          >
                            <template v-for="(item, index) in $vuetify.rtl ? appealTypeCodeAr : appealTypeCodeEn">
                              <v-radio
                                color="#a01c2a"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value"
                                readonly
                              >
                              </v-radio>
                              <v-spacer class="hidden_lr10" :key="index" v-if="index > 0"></v-spacer>
                            </template>
                          </v-radio-group>
                        </div>
                      </v-col>
                    </v-flex>

                    <v-flex class="item_box pa-0" style="border-bottom: none" v-if="appeal.appeal_type_code === '5701'">
                      <h2 class="m_title solo mt-35">{{ $t('appealoppsition.appeal.fields.egpo_action_information') }}</h2>
                      <v-row class="d-flex align-center pl-15 pr-15 pt-15">
                        <v-col cols="12" md="2">
                          <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.egpo_decision_date') }}</h2>
                        </v-col>
                        <v-col cols="12" md="3" class="ft-size12">
                          {{ appeal.appeal_decision_date }}
                        </v-col>
                      </v-row>
                      <v-row class="d-flex align-center pl-15 pr-15">
                        <v-col cols="12" md="2">
                          <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.egpo_decision_name') }}</h2>
                        </v-col>
                        <v-col cols="12" md="6" class="ft-size12">
                          {{ appeal.appeal_decision_name }}
                        </v-col>
                      </v-row>
                    </v-flex>

                    <v-flex class="item_box pa-0" style="border-bottom: none" v-if="appeal.appeal_type_code === '5702'">
                      <h2 class="m_title solo mt-35">{{ $t('appealoppsition.appeal.fields.egpo_action_information') }}</h2>
                      <v-row class="d-flex align-center pl-15 pr-15 pt-15">
                        <v-col cols="12" md="2">
                          <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.egpo_decision_date') }}</h2>
                        </v-col>
                        <v-col cols="12" md="3" class="ft-size12">
                          {{ appeal.appeal_decision_date }}
                        </v-col>
                      </v-row>
                      <v-row class="d-flex align-center pl-15 pr-15">
                        <v-col cols="12" md="2">
                          <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.appeal_committee_date') }}</h2>
                        </v-col>
                        <v-col cols="12" md="3" class="ft-size12">
                          {{ appeal.appeal_committee_date }}
                        </v-col>
                      </v-row>
                    </v-flex>
                  </v-layout>


                   <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.request_content_confirm === 'N'"
                          @click.stop="fnConfirmContent('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.request_content_confirm === 'Y'"
                          @click.stop="fnConfirmContent('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="nextDisabledYn"
                          @click="fnSubmit()"
                        >
                        <v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-2">
                  <DocumentViewer
                    :items="documentFileList"
                  />

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.ind_attached_confirm === 'N'"
                          @click.stop="fnConfirmAttacheddoc('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.ind_attached_confirm === 'Y'"
                          @click.stop="fnConfirmAttacheddoc('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="nextDisabledYn"
                          @click="fnSubmit()"
                        >
                        <v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

              </v-tabs>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation2 from '@/components/layout/ApplicationInformation2'

export default {
  components :{
    DocumentViewer,
    ApplicationInformation2
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      documentFileList: [],

      confirmYn : false,
      paymentYn : false,

      activeTab : 'tab-1',

      confirm : {
        request_content_confirm: '',
        ind_attached_confirm  : ''
      },

      appealTypeCodeAr: [],
      appealTypeCodeEn: [],

      appeal: {
        seq: null,
        amend_seq: null,
        appeal_committee_date: '',
        appeal_decision_date: '',
        appeal_decision_name: '',
        appeal_type_code: ''
      }
    }
  },
  computed : {
    nextDisabledYn (){
      return (
          this.confirm.request_content_confirm === 'N' ||
          this.confirm.ind_attached_confirm === 'N'
          )
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      let options = {
        upper_code: '5700'
      }
      utils.fnGetCodeList(options).then(list => {
        this.appealTypeCodeAr = list.ar
        this.appealTypeCodeEn = list.en
      })

      this.fnGetReceipt()
      this.fnGetAppeal()
      this.fnGetDocumentFileList()
      this.fnGetIndConfirmList()
      this.fnGetPayMentYn()
    },
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6415'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAppeal() {
      requestApi({
        url: '/receivings/appeal/'+ this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.appeal = {
              seq: res.data.seq,
              amend_seq: res.data.amend_seq,
              appeal_committee_date: res.data.appeal_committee_date,
              appeal_decision_date: res.data.appeal_decision_date,
              appeal_decision_name: res.data.appeal_decision_name,
              appeal_type_code: res.data.appeal_type_code
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAppeal()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetIndConfirmList(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.confirm.ind_attached_confirm  = res.data.ind_attached_confirm
            this.confirm.request_content_confirm = res.data.request_content_confirm
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetIndConfirmList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetPayMentYn(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/fee',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.payment_fee_type_code == '4502'){
              this.paymentYn = true
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPayMentYn()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmContent(confirmVal){
      let params = {
        request_content_confirm : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.request_content_confirm = confirmVal

            //다음탭으로 넘김
            if(confirmVal === 'Y'){
              this.activeTab = 'tab-2'
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmContent(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmAttacheddoc(confirmVal){
      let params = {
        ind_attached_confirm : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.ind_attached_confirm = confirmVal
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmAttacheddoc(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoBefore(){
      this.$router.push({path:'/appeal/step2/' + this.receipt_no})
    },
    fnSubmit(){
      requestApi({
        url: '/receivings/appeal/' + this.receipt_no + '/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            if (this.paymentYn) {
              this.$router.push({path : '/appeal/step4/' + this.receipt_no})
            } else {
              this.$router.push({path : '/myrequest/list'})
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetMessage(val){
      return val == 'Y' ? this.$t('common.message.confirm.success') : this.$t('common.message.cancel_confirm.success')
    },
  }
}
</script>